<!-- Login Page -->
<template>
  <v-container
    fluid
    fill-height
    :style="{ 'background-image': 'url(' + require('../assets/bg2.jpg') + ')', 'background-size': 'cover', padding: '0px' }"
  >
    <v-row no-gutters style="background:rgba(255,255,255,.00); border-radius:0px !important" align="center">
      <v-col cols="12">
        <v-card flat height="100vh" style="background:rgba(0,0,0,.0); border-radius:0px !important">
          <v-container fluid fill-height class="pa-0 ma-0">
            <v-row justify="center">
              <v-col col xl="3" lg="4" md="4" sm="6">
                <v-card elevation="15" style="background:rgba(255,255,255,.95) !important;">
                  <v-form @submit.prevent="login">
                     <v-row style="height:24vh" align="center" justify="center">
                    <v-col cols="12" class="justify-center ">
                      <v-img contain height="10vh" :src="require('@/assets/aquafeed.png')"></v-img>
                    </v-col>
                  </v-row>
                    <v-row justify="center" no-gutters>
                      <v-col cols="8">
                        <v-text-field
                          outlined
                          class="email"
                          prepend-inner-icon="mdi-account"
                          name="email"
                          label="Email"
                          id="email"
                          v-model="email"
                          type="email"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          outlined
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          prepend-inner-icon="mdi-lock"
                          name="password"
                          label="Password"
                          id="password"
                          v-model="password"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="8">
                        <v-btn style="height:40px" class="customCard" color="green darken-1" dark @click="login()" type="submit" block>
                          <v-icon small>mdi-login</v-icon>
                          &nbsp;&nbsp;&nbsp;Log in
                        </v-btn>
                      </v-col>
                      <v-col cols="8" class="pb-8">
                        <v-btn style="height:40px" class="customCard" color="yellow darken-3" dark block @click="dialogPassword = true">
                          <v-icon small>mdi-undo-variant</v-icon> &nbsp;&nbsp;&nbsp;Reset Password
                        </v-btn>
                        <!-- confirmation dialog asking for email to send an password reset email -->
                        <v-dialog v-model="dialogPassword" max-width="600">
                          <v-card>
                            <v-container>
                              <v-row justify="center">
                                <v-col cols="12" class="body-1 text-center">
                                  Please enter the email you wish to send a password reset link to!
                                </v-col>
                                <v-col cols="8" class="text-center">
                                  <v-text-field v-model="resetPasswordEmail" outlined dense label="Email"> </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row no-gutters justify="space-between">
                                <v-col cols="4" class="pt-3 pb-1 pl-2">
                                  <v-btn block @click="dialogPassword = false" color="red" dark>Cancel</v-btn>
                                </v-col>
                                <v-col cols="4" class="pt-3 pb-1 pr-2">
                                  <submit-button
                                    @click.native="resetPassword()"
                                    :block="true"
                                    :color="'primary'"
                                    :text="'Send Email'"
                                    :clickable="clickable"
                                  />
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <!-- <v-row justify="center" class="pb-6">
                      <v-col cols="8">
                        <v-btn block class="customCard" @click="goToSignUp()" outlined
                          ><v-icon small class="pr-2">mdi-account-plus</v-icon>Sign Up
                        </v-btn>
                    </v-col>
                    </v-row> -->
                  </v-form>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      email: "",
      password: "",
      message: {},
      alert: false,
      showPassword: false,
      dialogPassword: false,
      resetPasswordEmail: null,
      clickable: true,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //send a password reset email
    detectMobile() {
      if (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i) ||
        this.window.width < 750
      ) {
        return false;
      } else {
        return false;
      }
    },
    resetPassword() {
      this.clickable = false;
      this.$authService.resetPassword(this.resetPasswordEmail);
      this.clickable = true;
      this.resetPasswordEmail = null;
      this.dialogPassword = false;
    },
    login() {
      // this.$router.push({ path: "/test"});
      this.$authService.login(this.email, this.password);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    mobileRedirect() {
      window.location.href = "https://m.aquaop.wittaya-aqua.ca";
    },
    goToSignUp() {
      this.$router.push(`/signUp`);
    }
  },
};
</script>
